export type SingleCorpUser = {
	departmentName: string;
	departmentId: string;
	departmentUiColor: string;
	userName: string;
	userType: string;
	userId: string;
};

const model: types.models.InputModel = {
	departmentName: 'departmentName',
	departmentId: 'departmentId',
	departmentUiColor: 'departmentUiColor',
	userName: 'userName',
	userType: 'userType',
	userId: 'userId',
};

export default model;
